<div *ngIf="showBanner" class="banner">
  <img src="../../../../assets/images/clmsIcon.png">
  <div style="font-size: smaller;">{{ 'claims.list.Claimstable.clmsBanner' | translate }}</div>
  <mat-icon class="close-icon" (click)="closeBanner()">close</mat-icon>
</div>